/* eslint-disable @angular-eslint/prefer-inject, @angular-eslint/prefer-standalone -- Settings intentionally retains its tested NgModule constructor contract. */
import {Component, OnDestroy}   from '@angular/core';
import {MatDialog}              from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {BillingPolicyService}   from '@src/app/core/services/billing-policy.service';
import {AuthService}            from '@src/app/core/services/auth.service';
import {PermissionsService}     from '@src/app/core/services/permissions.service';
import {Breadcrumb}             from '@src/app/shared/models/breadcrumb.model';
import {Button}                 from '@src/app/shared/models/button.model';
import {Subscription}           from 'rxjs';
import {CreditLogsComponent}    from './credit-logs/credit-logs.component';
import {RolesService}           from '../services/roles.service';

@Component({
    standalone: false,
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnDestroy
{
    public breadcrumbs: Breadcrumb[] = [
        {
            title: 'Home',
            url: '/app/',
            active: false
        },
        {
            title: 'Settings',
            active: true
        },
    ];
    private readonly subscriptions = new Subscription();
    private billingPlan: string | null = null;

    public get canManageBilling(): boolean
    {
        return this.permissions.can('manage_billing');
    }

    public get buttons(): Button[]
    {
        if (this.selectedTab !== 7 || !['payg', 'grandfathered_payg'].includes(this.billingPlan ?? '')) return [];

        return [{
            type: 'button',
            material: 'stroked',
            color: undefined,
            title: 'Credit Logs',
            permission: 'view_credit_logs',
            callback: () => this.openCreditLogs(),
        }];
    }

    public activeRole = null;
    public selectedTab = 0;
    public tenantId: string;

    constructor(
        private roleService: RolesService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private authService: AuthService,
        private dialog: MatDialog,
        private billingPolicies: BillingPolicyService,
        private permissions: PermissionsService,
    )
    {
        this.subscriptions.add(this.roleService.role.subscribe(result => {
            this.activeRole = result;
        }));

        this.subscriptions.add(this.activatedRoute.params.subscribe(res => {
            if (res.id) {
                const tab = Number(res.id);
                if (tab === 3) {
                    this.changeTab(7);
                    return;
                }
                this.selectedTab = Number.isNaN(tab) ? 0 : tab;
            }
        }));
        this.subscriptions.add(this.billingPolicies.policy$.subscribe(policy => {
            this.billingPlan = policy?.plan ?? null;
        }));
        this.tenantId = this.authService.tenant?.id;
    }

    public openCreditLogs(): void
    {
        this.dialog.open(CreditLogsComponent, {
            width: '92vw',
            maxWidth: '1200px',
            maxHeight: '90vh',
            panelClass: 'mobile-width',
        });
    }

    public changeTab(tabIndex)
    {
        this.router.navigate(['app', 'settings', tabIndex]);
    }

    public ngOnDestroy(): void
    {
        this.subscriptions.unsubscribe();
    }
}
